import { useAxeptIo } from '../hooks/useAxeptIo.js';

const AxeptIoLoader = () => {
  useAxeptIo();
  return null;
};

export default AxeptIoLoader;
